<template>
    <div class="container-fluid">
        <div class="row project-cards">
            <h3>Contratos de Empleados</h3>
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-3">
                                <input class="form-control" placeholder="Buscar..." v-model="search" style="height: 33px; font-size: 12px;"/>
                            </div>
                            <div class="col-md-6">

                            </div>
                            <div class="col-md-3" style="text-align: right;">
                                <select class="form-select" v-model="employerSelect" style="float: right;" @change="changeFilters">
                                    <option v-for="(employer, index) in employers" :key="index" :value="employer.id">{{ employer.name }}</option>
                                </select>
                                <br /><br /><br />
                            </div>
                            <div class="col-xl-4 col-sm-6 col-xxl-3 col-ed-4 box-col-4" v-for="(employee, index) in filteredEmployees" :key="index">
                                
                                <div class="card social-profile">
                                    <div class="card-body">
                                        <div class="social-img-wrap">
                                            <div class="social-img"><img src="@/assets/images/user.png" alt="profile"></div>
                                            <div class="edit-icon">
                                                <svg>
                                                    <use href="@/assets/svg/icon-sprite.svg#profile-check"></use>
                                                </svg>
                                            </div>
                                        </div>
                                        <div class="social-details">
                                            <h5 class="mb-1" style="font-size: 12px;">{{ employee.name }}<br /><br />{{ employee.contract_sign_date ? "FIRMADO" : (employee.contract_view_date ? "VISUALIZADO" : (employee.contract_notify_date ? "ENVIADO" : 'POR ENVIAR')) }}</h5>
                                            <br />
                                            <router-link :to="'/panel/'+employee.id+'/employee'" target="_blank"><button v-if="employee.is_active" class="btn btn-info btn-xs" type="button">Ver Expediente</button></router-link>
                                            <button v-if="employee.is_active" class="btn btn-danger btn-xs" type="button" @click="loadEmployee(employee)" style="margin-left: 10px;" title="btn btn-success btn-xs" data-bs-toggle="modal" data-bs-target=".employee-contract-modal">Ver Contrato</button>
                                            <br />
                                            <ul class="social-follow">
                                                <li>
                                                    <h5 class="mb-0" style="font-size: 12px;">{{ employee.contract_notify_date ? $formatDate(employee.contract_notify_date) : '-' }}</h5><span class="f-light" style="font-size: 12px;">Enviado</span>
                                                </li>
                                                <li>
                                                    <h5 class="mb-0" style="font-size: 12px;">{{ employee.contract_view_date ? $formatDate(employee.contract_view_date) : '-' }}</h5><span class="f-light" style="font-size: 12px;">Visualizado</span>
                                                </li>
                                                <li>
                                                    <h5 class="mb-0" style="font-size: 12px;">{{ employee.contract_sign_date ? $formatDate(employee.contract_sign_date) : '-' }}</h5><span class="f-light" style="font-size: 12px;">Firmado</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal fade employee-modal" tabindex="-1" role="dialog" aria-labelledby="employeeModalLabel"aria-hidden="true">
                        <EmployeModal ref="employeeModal" />
                    </div>
                    <div class="modal fade employee-import-modal" tabindex="-1" role="dialog" aria-labelledby="employeeModalLabel"aria-hidden="true">
                        <EmployeImportModal ref="employeeImportModal" />
                    </div>

                    <div class="modal fade employee-contract-modal" tabindex="-1" role="dialog" aria-labelledby="contractEmployeeModalLabel" aria-hidden="true">
                        <EmployeeContractModal ref="employeeContractModal"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import getImage from "@/mixins/getImage"

import EmployeModal from "@/components/tmkt/employees/employee_modal.vue"
import EmployeImportModal from "@/components/tmkt/employees/employees_import_modal.vue"
import EmployeeContractModal from "@/components/tmkt/employees/employee_contract_modal.vue"

import ws from '@/services/employees'

export default {
    name: 'employees',
    components: {
        EmployeModal,
        EmployeImportModal,
        EmployeeContractModal
    },
    data(){
        return{
            employees: null,
            search: "",
            employers: null, 
            employerSelect: 0,
            lastEmployer: 0,
        }
    },
    mounted: async function() {
        let response2 = await ws.getEmployers(); 

        if(response2.type == "success"){
            this.employers = response2.data;

            this.employerSelect = this.employers[0].id;
        }

        this.changeFilters();

        let filters = {
            employer_id: this.employerSelect
        };

        let response = await ws.getEmployeesFiltered(filters);

        if(response.type == "success"){
            this.employees = response.data;
        }
    },
      methods: {
        loadEmployer(employer_id){
            this.$refs.employeeModal.loadEmployer(employer_id);
        },
        loadEmployee(employee){
            this.employee = employee;
            this.$refs.employeeContractModal.loadEmployee(employee);
        },
        async changeFilters () {
            let flag = false;
            if(this.lastEmployer != this.employerSelect){
                flag = true;

                this.lastEmployer = this.employerSelect;
            }

            let filters = {
                employer_id: this.employerSelect
            };

            let response = await ws.getEmployeesFiltered(filters);

            if(response.type == "success"){
                this.employees = response.data;
            }
        }
    },
    mixins: [getImage],
    computed: {
        ...mapState({
            card: (state) => state.common.usercard,
        }),
        filteredEmployees(){
            if(this.search == ''){
                return this.employees;
            }

            let query = this.search.toLowerCase();

            return this.employees.filter(item => item.name.toLowerCase().includes(query));
        }
    },
}

</script>

<style scoped>
    .project-cards {
        padding-top: 30px;
    }
</style>